import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { getRatingColor } from '../ratingColor'

export const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 4px;
  border: 1px solid ${COLORS.borderColor};
  background-color: ${COLORS.primaryExtraLight};
  white-space: nowrap;
`

export const DotsRow = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 2px;
`

export const Dot = styled.span<{ $filled: boolean; $score: number }>`
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: ${({ $filled, $score }) =>
    $filled ? getRatingColor($score) : COLORS.secondaryLight};
`
